import compare from '../../../utils/functions/sorting';

export const ptbrMonths = [
  'Jan',
  'Fev',
  'Mar',
  'Abr',
  'Mai',
  'Jun',
  'Jul',
  'Ago',
  'Set',
  'Out',
  'Nov',
  'Dez',
];

export const expDateOrder = (val) => {
  if (!val) return val;
  switch (val.toString().toLowerCase()) {
    case 'domingo':
    case 'sunday':
    case 'sun':
    case 'dom': return 0;
    case 'segunda-feira':
    case 'segunda':
    case 'monday':
    case 'mon':
    case 'seg': return 1;
    case 'terça':
    case 'terça-feira':
    case 'tuesday':
    case 'tue':
    case 'tues':
    case 'ter': return 2;
    case 'quarta':
    case 'quarta-feira':
    case 'wednesday':
    case 'wed':
    case 'qua': return 3;
    case 'quinta':
    case 'quinta-feira':
    case 'thursday':
    case 'thu':
    case 'thurs':
    case 'qui': return 4;
    case 'sexta':
    case 'sexta-feira':
    case 'friday':
    case 'fri':
    case 'sex': return 5;
    case 'sábado':
    case 'saturday':
    case 'sat':
    case 'sab': return 6;

    case 'janeiro':
    case 'january':
    case 'jan': return 0;
    case 'fevereiro':
    case 'february':
    case 'feb':
    case 'fev': return 1;
    case 'março':
    case 'march':
    case 'mar': return 2;
    case 'abril':
    case 'april':
    case 'apr':
    case 'abr': return 3;
    case 'maio':
    case 'may':
    case 'mai': return 4;
    case 'junho':
    case 'june':
    case 'jun': return 5;
    case 'julho':
    case 'july':
    case 'jul': return 6;
    case 'agosto':
    case 'august':
    case 'aug':
    case 'ago': return 7;
    case 'setembro':
    case 'september':
    case 'sept':
    case 'sep':
    case 'set': return 8;
    case 'outubro':
    case 'october':
    case 'oct':
    case 'out': return 9;
    case 'novembro':
    case 'november':
    case 'nov': return 10;
    case 'dezembro':
    case 'december':
    case 'dec':
    case 'dez': return 11;
    default: return val;
  }
};

export default function orderDatetime(data, keys, columns = []) {
  let dataClone = [...data];
  const keysClone = [...keys];
  const columnsClone = [...columns];

  if (columns.length > 1) {
    columnsClone.sort((a, b) => (compare(expDateOrder(a), expDateOrder(b))));
    const columnsIndex = columnsClone.map((el) => columns.indexOf(el));
    dataClone = dataClone.map((dt) => columnsIndex.map((index) => dt[index]));
  }
  keysClone.sort((a, b) => (compare(expDateOrder(a), expDateOrder(b))));
  const keysIndex = keysClone.map((el) => keys.indexOf(el));
  return {
    data: keysIndex.map((index) => dataClone[index]),
    indexes: keysIndex.map((index) => keys[index]),
    columns: columnsClone,
  };
}
